import script from "./OrganizationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationForm.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationForm.vue?vue&type=style&index=0&id=73fd5c11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fd5c11"]])

export default __exports__